module.exports = __webpack_public_path__ + "static/img/hz-icon.44c15f51.png";